import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useTranslation } from "react-i18next";

import "swiper/css";

import arrowLeft from "../../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../../assets/img/components/arrow-right.webp";
import img1 from "../../../assets/img/landingPageThree/sectionTwo/pagar.png";
import img2 from "../../../assets/img/landingPageThree/sectionTwo/bonus.png";
import img3 from "../../../assets/img/landingPageThree/sectionTwo/saude.png";
import img4 from "../../../assets/img/landingPageThree/sectionTwo/treinamento.png";
import img5 from "../../../assets/img/landingPageThree/sectionTwo/uniforme.png";
import img6 from "../../../assets/img/landingPageThree/sectionTwo/desconto.png";
import arrow from "../../../../assets/img/components/buttonBlue.webp"

const slides = [
  { img: img1, i18nKey: "lp4_why_card1" },
  { img: img2, i18nKey: "lp4_why_card2" },
  { img: img3, i18nKey: "lp4_why_card3" },
  { img: img4, i18nKey: "lp4_why_card4" },
  { img: img5, i18nKey: "lp4_why_card5" },
  { img: img6, i18nKey: "lp4_why_card6" },
];

const breakpoints = {
  1300: {
    slidesPerView: 4,
  },
  1000: {
    spaceBetween: 20,
  },
  900: {
    slidesPerView: 3,
  },
  600: {
    slidesPerView: 2,
  },
  0: {
    slidesPerView: 1,
  },
};

function SectionTwo() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="services" className={`sectionTwo ${isVisible ? "visible" : ""}`}>
        <img className={`arrow1 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
        <img className={`arrow2 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
        <div className="sectionTwoTitle">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp4_why_title")}
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("lp4_why_subtitle")}
          </p>
        </div>
        <Swiper
          slidesPerView={4}
          spaceBetween={40}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          speed={500}
          loop={true}
          modules={[Autoplay, Navigation]}
          breakpoints={breakpoints}
          className={`${isVisible ? "visible" : ""}`}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {slides.map(({ img, i18nKey }) => (
            <SwiperSlide key={i18nKey}>
              <div className={`card1 card ${isVisible ? "visible" : ""}`}>
                <img src={img} alt="" />
                <p>{t(i18nKey)}</p>
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}

export default SectionTwo;
